import _ from 'lodash'
import Flickity from 'flickity-fade'
import imagesLoaded from 'imagesloaded'
import SLIDER_CONFIG from './config'
import VIDEOS_NATIVE from '../video-native'
import VIDEOS_YOUTUBE from '../video-youtube'
import VIDEOS_VIMEO from '../video-vimeo'

class SliderClass {
    constructor( slider ) {
        this.DOM = {
            slider: slider,
            slides: _.selectAll( '.c-slide', slider ),
            controls: {
                prev: _.select( '.c-slider__control--prev', slider ),
                next: _.select( '.c-slider__control--next', slider ),
                swiper: _.select( '.c-slider__swipe-mobile', slider )
            }
        },

        this.slider = null
        this.prevNextButtons = JSON.parse( this.DOM.slider.getAttribute( 'data-prev-next-buttons' ) )
        this.pageDots = JSON.parse( this.DOM.slider.getAttribute( 'data-page-dots' ) )
        this.cellAlign = this.DOM.slider.getAttribute( 'data-cell-align' )
        this.contain =  JSON.parse( this.DOM.slider.getAttribute( 'data-contain' ) )
        this.autoPlay = this.DOM.slider.getAttribute( 'data-autoplay' ) == 'false' ? JSON.parse( this.DOM.slider.getAttribute( 'data-autoplay' ) ) : parseInt( this.DOM.slider.getAttribute( 'data-autoplay' ) )
        this.wrapAround = JSON.parse( this.DOM.slider.getAttribute( 'data-wrap-around' ) )
        this.groupCells = parseInt( this.DOM.slider.getAttribute( 'data-group-cells' ) )
        this.fade =  JSON.parse( this.DOM.slider.getAttribute( 'data-fade' ) )
        this.draggable =  JSON.parse( this.DOM.slider.getAttribute( 'data-draggable' ) )
        

        this.slidesLength = this.DOM.slides.length

        this.init()
    }

    init() {
        this._sliderParamsSet()
        this._sliderControlsShow()
        this._sliderCreate()
        console.log( 'Is resized' )
    }

    _sliderParamsSet() {
        if ( this.grouCells != 1 && window.innerWidth >= 768 ) {
            this.DOM.slides.forEach( ( slide ) => {  slide.style.width = `${100/this.groupCells}%`; })
        }
    }

    _sliderCreate() {
        this.slider = new Flickity( this.DOM.slider, {
            prevNextButtons: false,
            pageDots: this.pageDots,
            cellAlign: this.cellAlign,
            contain: this.contain,
            autoPlay: this.autoPlay,
            pauseAutoPlayOnHover: false,
            wrapAround: this.wrapAround,
            cellSelector: '.c-slide',
            imagesLoaded: true,
            groupCells: this.groupCells,
            fade: this.fade,
            draggable: this.draggable,
            on: {
                ready: () => {
                    this._sliderOnReady()
                },
                change: ( index ) => {
                    this._sliderChange( index )
                    this._sliderOnChange()
                }   
            }
        })
    }

    _sliderChange( index ) {        
        this._sliderChangeStopVideos()
        this.prevNextButtons ? this._sliderControlsShowOnChange( index ) : null
    }

    _sliderChangeStopVideos() {
        VIDEOS_NATIVE.forEach( ( video ) => { video._playerStopVideo() })
        VIDEOS_YOUTUBE.forEach( ( video ) => { video._playerStopVideo() })
        VIDEOS_VIMEO.forEach( ( video ) => { video._playerStopVideo() })
    }

    _sliderControlsShow() {
        if ( !this.prevNextButtons ) {
            _.addClass( this.DOM.slider, 'is--no-controls' )
        } else {
            this._sliderControlsListeners()
            this._sliderControlsPrevShow()
            this._sliderControlsNextShow()
        }
    }

    _sliderControlsListeners() {
        this.DOM.controls.prev.addEventListener( 'click', this._sliderPrev.bind( this ) )
        this.DOM.controls.next.addEventListener( 'click', this._sliderNext.bind( this ) )
    }

    _sliderPrev() {
        this.slider.previous()
    }

    _sliderNext() {
        this.slider.next()
    }

    _sliderControlsPrevShow() {
        if ( !this.wrapAround || this.slidesLength == 1 ) {
            _.addClass( this.DOM.controls.prev, 'c-slider__control--hide' )
        }
    }

    _sliderControlsNextShow() {
        if ( this.slidesLength == 1 ) {
            _.addClass( this.DOM.controls.next, 'c-slider__control--hide' )
            _.addClass( this.DOM.controls.swiper, 'c-slider__control--hide' )
        }
    }

    _sliderControlsShowOnChange( index ) {
        if (!this.wrapAround ) {
            if ( index == 0 ) {
                _.addClass( this.DOM.controls.prev, 'c-slider__control--hide' )
            } else if ( index > 0 && index < this.slidesLength - 1 ) {
                _.removeClass( this.DOM.controls.prev, 'c-slider__control--hide' )
                _.removeClass( this.DOM.controls.next, 'c-slider__control--hide' )
            } else {
                _.addClass( this.DOM.controls.next, 'c-slider__control--hide' )
            }
        }
    }

    _sliderOnReady( ) {
        // Add here yout custom code
    }

    _sliderOnChange( index ) {
        // Add here yout custom code
    }
}

const SLIDERS = []
SLIDER_CONFIG.sliders.forEach( ( slider ) => { SLIDERS.push( new SliderClass( slider ) ) } )
export default SLIDERS